module.exports = __webpack_public_path__ + "static/img/8.4e77670.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/zh/8.png
// module id = JH8A
// module chunks = 0